import { getSpatemActivityStatus } from '_store/spatem/utils';
import { useLocalization } from '@fluent/react';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { Tooltip } from 'react-leaflet';

import { SpatemStatus } from '../../../icons';
import styles from '../styles';
import { HoveringSPATEM, HoverTooltipProps } from './types';

const SpatemInfoTooltip: FC<HoverTooltipProps> = ({ hoveringElement }) => {
  const classes = styles();
  const { l10n } = useLocalization();
  const { spatem /* , offset */ } = hoveringElement as HoveringSPATEM;

  // Force re-render every second to update activity status based on time
  const [, setTick] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Calculate activity status - recalculates on every render to handle time-based updates
  const activityStatus = useMemo(() => getSpatemActivityStatus(spatem), [spatem]);

  const showTextOrHyphen = (text: string | number | undefined) => (text ? String(text) : '-');

  return (
    <Tooltip direction="top" sticky /* offset={offset || defaultOffset} */>
      <div className={classes.inlineHeader}>
        <div style={{ marginRight: '0.7rem' }}>
          <SpatemStatus status={activityStatus} />
        </div>
        <div style={{ marginBottom: '0.3rem' }} className={classes.tooltipHeader}>
          {l10n.getString('forms-info-box-spatem-info', {
            name: spatem?.identifier || spatem?.name || spatem?.id,
          })}
        </div>
      </div>
      <table>
        <tbody>
          <tr>
            <th className={classes.tooltipTableHeader}>
              {l10n.getString('forms-info-box-identifier')}
            </th>
            <td>{showTextOrHyphen(spatem?.identifier)}</td>
          </tr>
          <tr>
            <th className={classes.tooltipTableHeader}>
              {l10n.getString('forms-info-box-intersection-id')}
            </th>
            <td>{showTextOrHyphen(spatem?.payload?.intersection_id)}</td>
          </tr>
        </tbody>
      </table>
    </Tooltip>
  );
};

export default SpatemInfoTooltip;
